@if (loaderIcon | async) {
  <app-loader></app-loader>
}
@if (moduleType === 1) {
  <div bsModal #pricingPromotionPopup="bs-modal" class="modal fade" tabindex="-1" role="dialog"
    aria-labelledby="dialog-sizes-name1">
    <div class="modal-dialog modal-dialog-centered  modal-md ">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel" i18n="@@Pricing_Promotions">Pricing and Promotions</h5>
          <button type="button" class="close" (click)="onCancelPromo()" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body py-3 px-2">
          <div id="pricing_promo">
            <div>
              <app-discount-list [discounts]="categorizedDiscList?.ApplicableDiscounts"
                (emitupdatedDiscounts)="getUpdatedDiscounts($event)" [moduleType]="moduleType"
                [moveInSettings]="moveInSettings" [LatestURCToDatePlusOne]="LatestURCToDatePlusOne"
              [effectiveDatesList]="effectiveDatesList" [stopDatesList]="stopDatesList"></app-discount-list>
            </div>
            @if (categorizedDiscList?.ActiveDiscounts && categorizedDiscList?.ActiveDiscounts.length) {
              <div class="mb-4">
                <h6>Active Discounts</h6>
                <app-discount-list [discounts]="categorizedDiscList?.ActiveDiscounts"
                  (emitupdatedDiscounts)="getUpdatedDiscounts($event)" [moduleType]="moduleType"
                  [moveInSettings]="moveInSettings" [LatestURCToDatePlusOne]="LatestURCToDatePlusOne"
                [effectiveDatesList]="effectiveDatesList" [stopDatesList]="stopDatesList"></app-discount-list>
              </div>
            }
            @if (categorizedDiscList.ActiveAndStoppedDiscounts && categorizedDiscList?.ActiveAndStoppedDiscounts.length) {
              <div
                class="mb-4">
                <h6>Active and Stopped Discounts</h6>
                <app-discount-list [discounts]="categorizedDiscList?.ActiveAndStoppedDiscounts"
                  (emitupdatedDiscounts)="getUpdatedDiscounts($event)" [moduleType]="moduleType"
                  [moveInSettings]="moveInSettings" [LatestURCToDatePlusOne]="LatestURCToDatePlusOne"
                [effectiveDatesList]="effectiveDatesList" [stopDatesList]="stopDatesList"></app-discount-list>
              </div>
            }
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-primary mr-3" (click)="onCancelPromo()"
          i18n="@@Cancel">Cancel</button>
          <div class="button_tooltip">
            <button type="button" class="btn btn-primary" (click)="savePromo()" [disabled]="isPricingSaveDisabled()"
            i18n="@@Save">Save</button>
            @if (modifiedRecordsWithoutNotes.length) {
              <div class="button_tooltip_modal">
                <p class="mb-0">Please enter Modification Reason!</p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
}

<!-- Module Type 2 - Make Payment -->
@if (moduleType === 2) {
  <div id="pricing_promo">
    <div>
      <app-discount-list [discounts]="categorizedDiscList?.ApplicableDiscounts"
        (emitupdatedDiscounts)="getUpdatedDiscounts($event)" [moduleType]="moduleType" [moveInSettings]="moveInSettings"
        [LatestURCToDatePlusOne]="LatestURCToDatePlusOne" [effectiveDatesList]="effectiveDatesList"
      [stopDatesList]="stopDatesList"></app-discount-list>
    </div>
    @if (categorizedDiscList?.ActiveDiscounts && categorizedDiscList?.ActiveDiscounts.length) {
      <div class="mb-4">
        <h6>Active Discounts</h6>
        <app-discount-list [discounts]="categorizedDiscList?.ActiveDiscounts"
          (emitupdatedDiscounts)="getUpdatedDiscounts($event)" [moduleType]="moduleType" [moveInSettings]="moveInSettings"
          [LatestURCToDatePlusOne]="LatestURCToDatePlusOne" [effectiveDatesList]="effectiveDatesList"
        [stopDatesList]="stopDatesList"></app-discount-list>
      </div>
    }
    @if (categorizedDiscList.ActiveAndStoppedDiscounts && categorizedDiscList?.ActiveAndStoppedDiscounts.length) {
      <div
        class="mb-4">
        <h6>Active and Stopped Discounts</h6>
        <app-discount-list [discounts]="categorizedDiscList?.ActiveAndStoppedDiscounts"
          (emitupdatedDiscounts)="getUpdatedDiscounts($event)" [moduleType]="moduleType" [moveInSettings]="moveInSettings"
          [LatestURCToDatePlusOne]="LatestURCToDatePlusOne" [effectiveDatesList]="effectiveDatesList"
        [stopDatesList]="stopDatesList"></app-discount-list>
      </div>
    }
  </div>
}